export const detectScreenResolution = (): string => {
  return `${screen.width} x ${screen.height}`;
};

export const detectViewport = (): string => {
  return `${window.innerWidth} x ${window.innerHeight}`;
};
